export enum ToastMessageType {
    Success = 'success',
    Error = 'error',
    Static = 'static',
}